import NumberFormat from 'react-number-format';
import { Button, Item } from 'semantic-ui-react';
import './Listing.scss';
import build from '../builder';

const ListingCard = ({ listing }) => {
  return (
    <Item>
      <Item.Image size="small" src={listing.imageUrl} />
      <Item.Content className="listing-body">
        <Item.Header>{listing.name}</Item.Header>
        <Item.Description>
          <Item.Description>{listing.description}</Item.Description>
          <Item.Meta>
            <NumberFormat
              value={listing.price}
              displayType={'text'}
              thousandSeparator={true}
              prefix={'$'}
              renderText={(value, props) => <div {...props}>{value}</div>}
            />
          </Item.Meta>
        </Item.Description>
        <Item.Extra>
          <Button floated="right" content="Edit" basic color="grey" icon="edit" size="tiny" />
          <Button floated="right" content="Remove" basic negative icon="trash" size="tiny" />
        </Item.Extra>
      </Item.Content>
    </Item>
  );
};

export default build(ListingCard);
